<mat-nav-list>
 
       <button mat-button [matMenuTriggerFor]="menuProducts" class="nav-btn">
    Products
</button>


<button mat-button [matMenuTriggerFor]="menuSolutions" class="nav-btn">
    Solutions
</button>

<button mat-button [matMenuTriggerFor]="menuIntegrations" class="nav-btn">
    Integrations
</button>

<button mat-button [matMenuTriggerFor]="menuResources" class="nav-btn">
    Resources
</button>
       
          <a mat-button target="_blank" href="https://appiworks.jivrus.com/pricing" class="nav-btn"
          rel="noreferrer noopener">
          Pricing
        </a>  
     
    <mat-menu  #menuSolutions="matMenu"><menu-solutions></menu-solutions></mat-menu>
    <mat-menu  #menuProducts="matMenu"><menu-products> </menu-products></mat-menu>
    <mat-menu  #menuResources="matMenu"><menu-resources></menu-resources></mat-menu>
    <mat-menu  #menuIntegrations="matMenu"><menu-integrations></menu-integrations></mat-menu>
        
</mat-nav-list>